export default __webpack_public_path__ + "static/DSC_0021-710446889b5414582f9fc62adc188aac.jpg";